const toLocalDate = (date: Date): Date => {
  return new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000)
}

// Maybe just add T00:00:00 to the end of the date?

export default toLocalDate
